/**
 * Gift Selector - Direct inline function
 */

async function addGiftToCart(variantId, productTitle, cardId) {
  console.log('addGiftToCart called!', variantId, productTitle, cardId);

  const giftCard = document.getElementById(cardId);
  const giftButton = giftCard.querySelector('.gift-card--button');

  if (!giftCard || !giftButton) {
    console.error('Gift card or button not found');
    return;
  }

  // Already selected
  if (giftCard.classList.contains('selected')) {
    console.log('Already selected');
    return;
  }

  // Show loading
  giftButton.disabled = true;
  giftButton.classList.add('loading');

  console.log('Adding to cart, variant ID:', variantId);

  // First, remove any existing gifts
  try {
    await removeExistingGifts();
  } catch (error) {
    console.error('Error removing existing gifts:', error);
  }

  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId),
        quantity: 1,
        properties: {
          '_gift': 'Complimentary Gift',
          '_gift_name': productTitle
        }
      }]
    })
  })
  .then(response => {
    console.log('Response status:', response.status);
    return response.json();
  })
  .then(data => {
    console.log('Gift added successfully!', data);

    // Mark as selected
    document.querySelectorAll('.gift-card').forEach(card => {
      card.classList.remove('selected');
    });
    giftCard.classList.add('selected');

    giftButton.disabled = false;
    giftButton.classList.remove('loading');

    // Refresh cart drawer with updated content (no page reload!)
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else if (typeof refreshCartDrawer === 'function') {
      refreshCartDrawer();
    } else {
      // Trigger cart refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  })
  .catch(error => {
    console.error('Error adding gift:', error);
    giftButton.disabled = false;
    giftButton.classList.remove('loading');
    alert('Error: ' + error.message);
  });
}

/**
 * Remove any existing gifts from cart
 */
async function removeExistingGifts() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    // Find all items with _gift property
    const giftItems = cart.items.filter(item => {
      return item.properties && item.properties._gift;
    });

    // Remove each gift item
    for (const giftItem of giftItems) {
      const lineIndex = cart.items.indexOf(giftItem) + 1;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      });
      console.log('🗑️ Removed existing gift:', giftItem.title);
    }
  } catch (error) {
    console.error('Error in removeExistingGifts:', error);
    throw error;
  }
}
